import { atom } from "jotai";

export const $draftCommitMessage = atom("");
$draftCommitMessage.debugLabel = "draftCommitMessage";
